<template>
  <div
    class="w-full"
    :class="{ 'px-4 lg:max-w-xl': isMobileMoneyPayoutMethod }"
    test-id="main"
  >
    <div
      v-if="isNewRecipientMode"
      @click="goBack"
      class="cursor-pointer flex items-center my-5 justify-start border rounded-lg w-20 px-3 py-2"
    >
      <back-arrow />
      <p class="text-root-4 ml-2 font-normal text-xs">Back</p>
    </div>
    <div
      v-if="isNewRecipientMode"
      class="border border-primary rounded-lg py-3 cursor-pointer flex flex-row items-center bg-info-subtle justify-center my-5"
      @click="openDrawer('showBeneficiaryDrawer')"
    >
      <people-icon class="h-5 w-5 lg:h-6 lg:w-6 mr-2" />
      <p class="text-sm lg:text-base font-normal text-primary">
        Use Beneficiary
      </p>
    </div>
    <div
      class="w-full bg-root"
      :class="{ 'border rounded-lg': isNewRecipientMode }"
    >
      <div
        v-if="!transferDestinationIsAsset && isNewRecipientMode"
        class="text-root-1 p-2 lg:p-6"
      >
        <p
          v-if="!transferSourceIsGlobalFiat"
          class="text-lg font-normal lg:text-2xl p-4 lg:p-2 text-root-2"
        >
          New Recipient
        </p>
        <p
          v-else
          class="text-lg font-normal lg:text-2xl p-4 lg:p-2 text-root-2"
        >
          {{
            isMobileMoneyPayoutMethod && mobileWalletSupportedCurrencies
              ? 'New Recipient Details'
              : 'Transfer Details'
          }}
        </p>
      </div>
      <destination-is-global-fx
        v-if="transferDestinationIsGlobalFiat"
        @next="next"
      />
      <destination-is-local v-if="transferDestinationIsLocal" @next="next" />
      <div v-if="transferDestinationIsAsset">
        <asset-transfer-details @next="next" />
      </div>
    </div>
    <beneficiary-drawer
      v-if="showBeneficiaryDrawer"
      :showDrawer="showBeneficiaryDrawer"
      @closeDrawer="closeDrawer('showBeneficiaryDrawer')"
      @toReview="next"
    />
  </div>
</template>
<script>
import country from '@/mixins/getCountryDetails'
import localDeposit from '@/mixins/localDeposit.js'
export default {
  name: 'RecipientDetails',
  mixins: [country, localDeposit],
  props: {
    formType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showBeneficiaryDrawer: false
    }
  },
  methods: {
    closeDrawer (arg) {
      this[arg] = false
    },
    openDrawer (arg) {
      this[arg] = true
    },
    next () {
      this.$emit('next')
    },
    goBack () {
      this.$store.dispatch('terminal/beneficiaryOption', true)
      this.$store.dispatch('terminal/usedBeneficiary', false)
      this.$emit('prev')
    }
  },
  computed: {
    isEditMode () {
      return this.formType === 'edit'
    },
    isNewRecipientMode () {
      return this.formType === 'new recipient'
    }
  },
  components: {
    AssetTransferDetails: () =>
      import('@/components/terminal/terminalSkeleton/AssetTransferDetails.vue'),
    BackArrow: () => import('@/assets/icons/BackArrow.vue'),
    PeopleIcon: () => import('@/assets/icons/PeopleIcon.vue'),
    BeneficiaryDrawer: () =>
      import('@/components/v2/terminal/drawers/BeneficiaryDrawer.vue'),
    DestinationIsGlobalFx: () =>
      import(
        '@/components/v2/terminal/layout/terminalSkeleton/recipient/forms/DestinationIsGlobalFx.vue'
      ),
    DestinationIsLocal: () =>
      import(
        '@/components/v2/terminal/layout/terminalSkeleton/recipient/forms/DestinationIsLocal.vue'
      )
  }
}
</script>

<style>
.card {
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.1),
    0px 4px 8px rgba(3, 2, 7, 0.1);
  border-radius: 15px;
}

.btn {
  height: 4.375rem;
  border-radius: 200px;
}

> .el-select .el-input__inner {
  padding: 0 0 0 12px;
  font-weight: 500;
}

>>> .el-select .el-input.is-focus .el-input__inner {
  border-color: #c7c8d2;
}

>>> .el-select .el-input__inner:focus {
  border-color: #c7c8d2;
}

>>> .el-form-item__label,
>>> .el-form-item__content {
  line-height: 12px;
  font-size: 12px;
  font-weight: 600;
}

/* >>> .el-input__inner-text {
  padding-left: 0rem;
} */
>>> .el-checkbox__inner {
  border: 2px solid #c7c8d2;
  width: 20px;
  height: 20px;
}

>>> .el-checkbox__inner::after {
  top: 1px;
  left: 5px;
  width: 5px;
  height: 9px;
}

>>> .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
}

>>> .el-checkbox__inner:hover {
  border-color: var(--color-primary);
}

>>> .el-form--label-top .el-form-item__label {
  padding: 4;
}

>>> .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: var(--color-primary);
}

>>> .el-input__inner {
  border-radius: 8px;
  border-color: #c7c8d2;
  height: 48px;
}

>>> .el-form-item {
  margin-bottom: 15px;
}
>>> .el-select .el-input.is-disabled .el-input__inner {
  background-color: transparent !important;
  cursor: pointer !important;
}
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* For Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
